var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"hf-main-layout"},[_c('div',{staticStyle:{"background-color":"#CCCCCC"}},[_c('hf-header-gray',{staticClass:"wb-display"})],1),_c('div',{staticClass:"hf-main-layout-main"},[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }